import React from "react";
import EventsDeletedTable from "../../../Components/EventsDeletedTable/EventsDeletedTable";

export const DeletedEvents = () => {
  return (
    <div className="container-fluid container-md">
      <EventsDeletedTable/>
    </div>
  );
};
